import React from 'react';
import { Form } from 'react-final-form';

import ProjectRequestFormInner from './ProjectRequestFormInner';
import validate from '../../../utils/validate';
import { projectRequestFormYupValidation } from './validation';
import sendRequest from '../../../service/sendRequest';
import callApi from '../../../service/callApi';

function ProjectRequestForm({ onSentMessage }) {
  const initialValues = {
    projectType: '',

    name: '',
    email: '',

    users: '',

    supplementaryInfo: '',

    relevantUrl: '',
    relevantCompetitorsUrls: '',
  };

  const handleRequestForNewProject = async (values) => {
    const notEmptyValues = Object.fromEntries(Object.entries(values).filter(([_, value]) => value !== ''));
    await sendRequest(() => callApi.post('/api/support/request/project', notEmptyValues));
    onSentMessage();
  };
  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleRequestForNewProject}
      validate={(values) => validate(values, projectRequestFormYupValidation())}
      subscription={{ submitting: true, pristine: true }}>
      {({ handleSubmit }) => <ProjectRequestFormInner onSubmit={handleSubmit} />}
    </Form>
  );
}

export default ProjectRequestForm;
